import { useEffect, useState } from 'react';
// @mui
import { Box } from '@mui/material';
import Lottie from 'lottie-react';
import groovyWalkAnimation from '../../_json/loading-animation.json';


// ----------------------------------------------------------------------

export default function PreloaderScreen({ sx, ...other }) {

  // const [mounted, setMounted] = useState(false);
  //
  // useEffect(() => {
  //   setMounted(true);
  // }, []);
  //
  // if (!mounted) {
  //   return null;
  // }

  return (
    <Box
      sx={{
        right: 0,
        width: 1,
        bottom: 0,
        height: 1,
        zIndex: 9998,
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#04173A',
        ...sx,
      }}
      {...other}
    >
      <Lottie animationData={groovyWalkAnimation} loop={Boolean(true)} />
    </Box>
  );
}
